import { gdImgSrcPolicy, gdOssUrl } from "@/utils/imageUrl";
import dynamic from "next/dynamic";
import { type CountDownProps } from "./countDown";
import styles from "./index.module.less";

const CountDown = dynamic(() => import("./countDown"), { ssr: false });

interface ActivityBannerProps {
  foreground: IGroceryUploadFile[];
  background: IGroceryUploadFile[];
  /**点击跳转链接 */
  href: string;
  buttons: {
    text: string;
    bg: string | IGroceryUploadFile[];
    href: string;
    textSize: number | string;
    textColor: string;
    width: number | string;
    height: number | string;
  }[];
  countDown: CountDownProps;
}

export default function ActivityBanner(props: ActivityBannerProps) {
  const { href, foreground, background, countDown, buttons } = props;

  const content = (
    <>
      {foreground?.[0]?.url && (
        <img
          className={styles.front}
          {...gdImgSrcPolicy(foreground?.[0]?.url, {
            height: 250,
          })}
          alt="活动前景图"
        />
      )}
      <img
        className={styles.back}
        {...gdImgSrcPolicy(background?.[0]?.url, {
          width: 1920,
        })}
        alt="活动背景图"
      />

      {buttons && (
        <div className={styles.buttons}>
          {buttons.map((button, index) => {
            return (
              <a
                href={button.href}
                key={index}
                target="_blank"
                rel="nofollow"
                className={styles.button}
                data-gd-click="resource_loc_click"
                data-resource-type="banner"
                data-resource-id={index}
                data-resource-title={"活动banner按钮"}
                style={{
                  background: `url(${gdOssUrl(
                    typeof button.bg === "string"
                      ? button.bg
                      : button.bg?.[0]?.url,
                    { height: button.height, width: button.width }
                  )}) no-repeat center center / contain`,
                  fontSize: +button.textSize || button.textSize,
                  color: button.textColor,
                  width: +button.width || button.width,
                  height: +button.height || button.height,
                }}
              >
                {button.text}
              </a>
            );
          })}
        </div>
      )}

      <CountDown className={styles.countDown} {...countDown} />
    </>
  );

  return href ? (
    <a
      href={href}
      target="_blank"
      rel="nofollow"
      className={styles.activityBanner}
      data-gd-click="resource_loc_click"
      data-resource-type="banner"
      data-resource-id={0}
      data-resource-title={"活动banner"}
    >
      {content}
    </a>
  ) : (
    <div className={styles.activityBanner}>{content}</div>
  );
}
